module.exports = __webpack_public_path__ + "static/media/Sony SmartWatch 3 Black Open.7977d105.png";